import { BluPayApiError } from "../api/client";

/**
 * Staff-console error text. Admin services throw raw Axios errors, and staff
 * may read the backend `detail`; a 422 `detail` is a list of Pydantic
 * errors, which is joined so React can render it.
 */
export function readApiError(err, fallback) {
  const detail = err?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail) && detail.length) {
    return detail.map((item) => item?.msg).filter(Boolean).join(", ") || fallback;
  }

  if (err instanceof BluPayApiError && err.message) {
    return err.message;
  }

  return fallback;
}
